module.exports = __webpack_public_path__ + "static/diamond-451ed459925deeb4f3d0c76370a0b0cb.svg";